export default __webpack_public_path__ + "static/media/chartres6.9521ffc9.jpg";